import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ProjectDeleteModalUI from './ProjectDeleteModalUI.js'

class ProjectDeleteModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
    }
  }

  render() {
    return (
      <ProjectDeleteModalUI
        context={this.props.context}
        project={this.props.project}
        messageList={this.props.messageList}
        deleteMode={this.props.deleteMode}
        errorList={this.state.errorList}
        setErrorList={(errorList) => {this.setState({errorList: errorList})}}
        successMsg={this.state.successMsg}
        onCancel={this.props.onCancel}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
      />
    )
  }

  UNSAFE_componentWillMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: null,
      submitted: true
    })

    let context = this.props.context

    RestApiUtils.delete(context,
      `/api/accounts/${context.session.accountId}/projects/${this.props.project.projectId}`,
      this.onSubmitCallback
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    let context = this.props.context
    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId))
      setTimeout(() => {
        this.props.history.push('/projects')
      }, 2000)
    }
  }

}

export default withRouter(ProjectDeleteModalSF)
